import { render, staticRenderFns } from "./editProduct.vue?vue&type=template&id=ddc3f1ec&scoped=true&"
import script from "./editProduct.vue?vue&type=script&lang=js&"
export * from "./editProduct.vue?vue&type=script&lang=js&"
import style0 from "./editProduct.vue?vue&type=style&index=0&id=ddc3f1ec&prod&lang=css&"
import style1 from "./editProduct.vue?vue&type=style&index=1&id=ddc3f1ec&prod&lang=scss&scoped=true&"
import style2 from "./editProduct.vue?vue&type=style&index=2&id=ddc3f1ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc3f1ec",
  null
  
)

export default component.exports